module.exports = __webpack_public_path__ + "5a45ce7375cdf38946bf176649cf41b8.svg";